import { Panel, StatelessAccordion } from 'baseui/accordion'
import { StyledLi, StyledText } from './styled-components'
import useMeterInformationAccordion from './useMeterInformationAccordion'

const MeterInformationAccordion = ({ mainPanels, otherPanels }) => {
  const { isPulse, expanded, onExpandedChange, accordionOverrides } = useMeterInformationAccordion()
  const separator = <p>:</p>

  return (
    <StatelessAccordion expanded={expanded} onChange={onExpandedChange} overrides={accordionOverrides}>
      {mainPanels?.map((content, indexPanel) => {
        return (
          <Panel title={content.title} key={'basic' + indexPanel}>
            <>
              {content.text.map((content, index) => {
                return (
                  <StyledLi key={'p_basic' + index} $pulse={isPulse}>
                    {content?.text} {content?.text && !isPulse ? separator : ''}{' '}
                    <StyledText $pulse={isPulse}>{content?.value}</StyledText>
                  </StyledLi>
                )
              })}
            </>
          </Panel>
        )
      })}
      {otherPanels?.map((content, indexPanel) => {
        return (
          <Panel title={content.title} key={'details' + indexPanel}>
            <>
              {content.text.map((content, index) => {
                return (
                  <StyledLi key={'p_panels' + index} $pulse={isPulse}>
                    {content?.text} <StyledText $pulse={isPulse}>{content?.value}</StyledText>
                  </StyledLi>
                )
              })}
            </>
          </Panel>
        )
      })}
    </StatelessAccordion>
  )
}

export default MeterInformationAccordion
